import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import { findWorkflowProcess, createWorkflowProcess, updateWorkflowProcess } from "@/api/workflowProcess"; //  此处请自行替换地址
import gvaWfd from "@/components/gva-wfd";
import { getUserList } from "@/api/user";
import { getAuthorityList } from "@/api/authority";
export default {
  name: "Workflow",
  components: {
    gvaWfd: gvaWfd
  },
  data: function data() {
    return {
      visible: false,
      lang: "zh",
      done: false,
      demoData: {
        nodes: [],
        edges: []
      },
      wkType: "create",
      users: [],
      authorities: [],
      processModel: {
        id: '',
        name: '',
        category: '',
        clazz: 'process',
        dataObjs: [],
        signalDefs: [],
        messageDefs: []
      },
      groups: [],
      categorys: []
    };
  },
  methods: {
    save: function save() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var obj, processModel, res, _res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.visible = false;
              obj = _this.$refs["wfd"].graph.save();
              processModel = _this.$refs["wfd"].processModel;
              processModel.edges = obj.edges;
              processModel.nodes = JSON.parse(JSON.stringify(obj.nodes));
              processModel.nodes.map(function (item) {
                if (item.assignValue) {
                  item.assignValue = "," + String(item.assignValue) + ",";
                }
              });
              if (processModel.id) {
                _context.next = 9;
                break;
              }
              _this.$message({
                type: "error",
                message: "流程id必填，点击空白处填写流程基本信息"
              });
              return _context.abrupt("return");
            case 9:
              if (!(_this.$route.query.type == 'edit')) {
                _context.next = 16;
                break;
              }
              _context.next = 12;
              return updateWorkflowProcess(processModel);
            case 12:
              res = _context.sent;
              if (res.code == 0) {
                _this.$message({
                  type: "success",
                  message: "编辑成功"
                });
              }
              _context.next = 20;
              break;
            case 16:
              _context.next = 18;
              return createWorkflowProcess(processModel);
            case 18:
              _res = _context.sent;
              if (_res.code == 0) {
                _this.$message({
                  type: "success",
                  message: "创建成功"
                });
              }
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    saveXML: function saveXML() {
      console.log(this.$refs["wfd"].graph.saveXML());
    },
    saveImg: function saveImg() {
      console.log(this.$refs["wfd"].graph.saveImg());
    },
    fmtAuthority: function fmtAuthority(authorityList, list) {
      var _this2 = this;
      authorityList.map(function (item) {
        list.push({
          id: item.authorityId,
          name: item.authorityName
        });
        if (item.children) {
          _this2.fmtAuthority(item.children, list);
        }
      });
    }
  },
  created: function created() {
    var _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var userRes, authorityRes, res;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getUserList({
              page: 1,
              pageSize: 9999999
            });
          case 2:
            userRes = _context2.sent;
            if (userRes.code == 0) {
              userRes.data.list.map(function (item) {
                _this3.users.push({
                  id: item.ID,
                  name: item.nickName
                });
              });
            }
            _context2.next = 6;
            return getAuthorityList({
              page: 1,
              pageSize: 9999999
            });
          case 6:
            authorityRes = _context2.sent;
            if (authorityRes.code == 0) {
              _this3.fmtAuthority(authorityRes.data.list, _this3.authorities);
            }
            if (!_this3.$route.query.id) {
              _context2.next = 15;
              break;
            }
            _context2.next = 11;
            return findWorkflowProcess({
              id: _this3.$route.query.id
            });
          case 11:
            res = _context2.sent;
            _this3.disabled = _this3.$route.query.type == "view";
            if (res.code == 0) {
              res.data.reworkflowProcess.nodes.map(function (item) {
                if (item.assignValue) {
                  var watiUseArr = item.assignValue.substr(1, item.assignValue.length - 2).split(",");
                  if (item.assignType == 'user') {
                    item.assignValue = [];
                    watiUseArr.map(function (i) {
                      item.assignValue.push(Number(i));
                    });
                  } else {
                    item.assignValue = watiUseArr;
                  }
                }
              });
              _this3.demoData.nodes = res.data.reworkflowProcess.nodes;
              delete res.data.reworkflowProcess.nodes;
              _this3.demoData.edges = res.data.reworkflowProcess.edges;
              delete res.data.reworkflowProcess.edges;
              _this3.processModel = res.data.reworkflowProcess;
            }
            _this3.wkType = _this3.$route.query.type;
          case 15:
            _this3.done = true;
          case 16:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }
};